import { ISO } from "../languages/countryIsoCodes";

/**
 * A list of all countries. Used to populate country selection fields in the CMS.
 * If you're looking for just locations that Too Good To Go operate in, check
 * `packages/config/languages` instead.
 *
 * Country ISO codes should match those found in `packages/config/languages`, and is how
 * we cross-reference countries to our markets.
 */
export const allCountries: Array<{
  title: string;
  value: string;
  code: string;
  countryIso: ISO;
  phoneCode: string;
  flag: string;
}> = [
  {
    title: 'Afghanistan',
    value: 'afghanistan',
    code: 'AF',
    countryIso: ISO.AFG,
    phoneCode: '+93',
    flag: '🇦🇫',
  },
  {
    title: 'Albania',
    value: 'albania',
    code: 'AL',
    countryIso: ISO.ALB,
    phoneCode: '+355',
    flag: '🇦🇱',
  },
  {
    title: 'Algeria',
    value: 'algeria',
    code: 'DZ',
    countryIso: ISO.DZA,
    phoneCode: '+213',
    flag: '🇩🇿',
  },
  {
    title: 'American Samoa',
    value: 'american samoa',
    code: 'AS',
    countryIso: ISO.ASM,
    phoneCode: '+1-684',
    flag: '🇦🇸',
  },
  {
    title: 'Andorra',
    value: 'andorra',
    code: 'AD',
    countryIso: ISO.AND,
    phoneCode: '+376',
    flag: '🇦🇩',
  },
  {
    title: 'Angola',
    value: 'angola',
    code: 'AO',
    countryIso: ISO.AGO,
    phoneCode: '+244',
    flag: '🇦🇴',
  },
  {
    title: 'Anguilla',
    value: 'anguilla',
    code: 'AI',
    countryIso: ISO.AIA,
    phoneCode: '+1-264',
    flag: '🇦🇮',
  },
  {
    title: 'Antarctica',
    value: 'antarctica',
    code: 'AQ',
    countryIso: ISO.ATA,
    phoneCode: '+672',
    flag: '🇦🇶',
  },
  {
    title: 'Antigua and Barbuda',
    value: 'antigua and barbuda',
    code: 'AG',
    countryIso: ISO.ATG,
    phoneCode: '+1-268',
    flag: '🇦🇬',
  },
  {
    title: 'Argentina',
    value: 'argentina',
    code: 'AR',
    countryIso: ISO.ARG,
    phoneCode: '+54',
    flag: '🇦🇷',
  },
  {
    title: 'Armenia',
    value: 'armenia',
    code: 'AM',
    countryIso: ISO.ARM,
    phoneCode: '+374',
    flag: '🇦🇲',
  },
  {
    title: 'Aruba',
    value: 'aruba',
    code: 'AW',
    countryIso: ISO.ABW,
    phoneCode: '+297',
    flag: '🇦🇼',
  },
  {
    title: 'Australia',
    value: 'australia',
    code: 'AU',
    countryIso: ISO.AUS,
    phoneCode: '+61',
    flag: '🇦🇺',
  },
  {
    title: 'Austria',
    value: 'austria',
    code: 'AT',
    countryIso: ISO.AUT,
    phoneCode: '+43',
    flag: '🇦🇹',
  },
  {
    title: 'Azerbaijan',
    value: 'azerbaijan',
    code: 'AZ',
    countryIso: ISO.AZE,
    phoneCode: '+994',
    flag: '🇦🇿',
  },
  {
    title: 'Bahamas',
    value: 'bahamas',
    code: 'BS',
    countryIso: ISO.BHS,
    phoneCode: '+1-242',
    flag: '🇧🇸',
  },
  {
    title: 'Bahrain',
    value: 'bahrain',
    code: 'BH',
    countryIso: ISO.BHR,
    phoneCode: '+973',
    flag: '🇧🇭',
  },
  {
    title: 'Bangladesh',
    value: 'bangladesh',
    code: 'BD',
    countryIso: ISO.BGD,
    phoneCode: '+880',
    flag: '🇧🇩',
  },
  {
    title: 'Barbados',
    value: 'barbados',
    code: 'BB',
    countryIso: ISO.BRB,
    phoneCode: '+1-246',
    flag: '🇧🇧',
  },
  {
    title: 'Belarus',
    value: 'belarus',
    code: 'BY',
    countryIso: ISO.BLR,
    phoneCode: '+375',
    flag: '🇧🇾',
  },
  {
    title: 'Belgium',
    value: 'belgium',
    code: 'BE',
    countryIso: ISO.BEL,
    phoneCode: '+32',
    flag: '🇧🇪',
  },
  {
    title: 'Belize',
    value: 'belize',
    code: 'BZ',
    countryIso: ISO.BLZ,
    phoneCode: '+501',
    flag: '🇧🇿',
  },
  {
    title: 'Benin',
    value: 'benin',
    code: 'BJ',
    countryIso: ISO.BEN,
    phoneCode: '+229',
    flag: '🇧🇯',
  },
  {
    title: 'Bermuda',
    value: 'bermuda',
    code: 'BM',
    countryIso: ISO.BMU,
    phoneCode: '+1-441',
    flag: '🇧🇲',
  },
  {
    title: 'Bhutan',
    value: 'bhutan',
    code: 'BT',
    countryIso: ISO.BTN,
    phoneCode: '+975',
    flag: '🇧🇹',
  },
  {
    title: 'Bolivia',
    value: 'bolivia',
    code: 'BO',
    countryIso: ISO.BOL,
    phoneCode: '+591',
    flag: '🇧🇴',
  },
  {
    title: 'Bonaire, Sint Eustatius and Saba',
    value: 'bonaire',
    code: 'BQ',
    countryIso: ISO.BES,
    phoneCode: '+599',
    flag: '🇧🇶',
  },
  {
    title: 'Bosnia and Herzegovina',
    value: 'bosnia and herzegovina',
    code: 'BA',
    countryIso: ISO.BIH,
    phoneCode: '+387',
    flag: '🇧🇦',
  },
  {
    title: 'Botswana',
    value: 'botswana',
    code: 'BW',
    countryIso: ISO.BWA,
    phoneCode: '+267',
    flag: '🇧🇼',
  },
  {
    title: 'Brazil',
    value: 'brazil',
    code: 'BR',
    countryIso: ISO.BRA,
    phoneCode: '+55',
    flag: '🇧🇷',
  },
  {
    title: 'British Indian Ocean Territory',
    value: 'british indian ocean territory',
    code: 'IO',
    countryIso: ISO.IOT,
    phoneCode: '+246',
    flag: '🇮🇴',
  },
  {
    title: 'Brunei Darussalam',
    value: 'brunei darussalam',
    code: 'BN',
    countryIso: ISO.BRN,
    phoneCode: '+673',
    flag: '🇧🇳',
  },
  {
    title: 'Bulgaria',
    value: 'bulgaria',
    code: 'BG',
    countryIso: ISO.BGR,
    phoneCode: '+359',
    flag: '🇧🇬',
  },
  {
    title: 'Burkina Faso',
    value: 'burkina faso',
    code: 'BF',
    countryIso: ISO.BFA,
    phoneCode: '+226',
    flag: '🇧🇫',
  },
  {
    title: 'Burundi',
    value: 'burundi',
    code: 'BI',
    countryIso: ISO.BDI,
    phoneCode: '+257',
    flag: '🇧🇮',
  },
  {
    title: 'Cabo Verde',
    value: 'cabo verde',
    code: 'CV',
    countryIso: ISO.CPV,
    phoneCode: '+238',
    flag: '🇨🇻',
  },
  {
    title: 'Cambodia',
    value: 'cambodia',
    code: 'KH',
    countryIso: ISO.KHM,
    phoneCode: '+855',
    flag: '🇰🇭',
  },
  {
    title: 'Cameroon',
    value: 'cameroon',
    code: 'CM',
    countryIso: ISO.CMR,
    phoneCode: '+237',
    flag: '🇨🇲',
  },
  {
    title: 'Canada',
    value: 'canada',
    code: 'CA',
    countryIso: ISO.CAN,
    phoneCode: '+1',
    flag: '🇨🇦',
  },
  {
    title: 'Cayman Islands',
    value: 'cayman islands',
    code: 'KY',
    countryIso: ISO.CYM,
    phoneCode: '+1-345',
    flag: '🇰🇾',
  },
  {
    title: 'Central African Republic',
    value: 'central african republic',
    code: 'CF',
    countryIso: ISO.CAF,
    phoneCode: '+236',
    flag: '🇨🇫',
  },
  {
    title: 'Chile',
    value: 'chile',
    code: 'CL',
    countryIso: ISO.CHL,
    phoneCode: '+56',
    flag: '🇨🇱',
  },
  {
    title: 'China',
    value: 'china',
    code: 'CN',
    countryIso: ISO.CHN,
    phoneCode: '+86',
    flag: '🇨🇳',
  },
  {
    title: 'Colombia',
    value: 'colombia',
    code: 'CO',
    countryIso: ISO.COL,
    phoneCode: '+57',
    flag: '🇨🇴',
  },
  {
    title: 'Comoros',
    value: 'comoros',
    code: 'KM',
    countryIso: ISO.COM,
    phoneCode: '+269',
    flag: '🇰🇲',
  },
  {
    title: 'Congo, Democratic Republic of the',
    value: 'democratic republic of the congo',
    code: 'CD',
    countryIso: ISO.COD,
    phoneCode: '+243',
    flag: '🇨🇩',
  },
  {
    title: 'Congo, Republic of the',
    value: 'republic of the congo',
    code: 'CG',
    countryIso: ISO.COG,
    phoneCode: '+242',
    flag: '🇨🇬',
  },
  {
    title: 'Cook Islands',
    value: 'cook islands',
    code: 'CK',
    countryIso: ISO.COK,
    phoneCode: '+682',
    flag: '🇨🇰',
  },
  {
    title: 'Costa Rica',
    value: 'costa rica',
    code: 'CR',
    countryIso: ISO.CRI,
    phoneCode: '+506',
    flag: '🇨🇷',
  },
  {
    title: 'Croatia',
    value: 'croatia',
    code: 'HR',
    countryIso: ISO.HRV,
    phoneCode: '+385',
    flag: '🇭🇷',
  },
  {
    title: 'Cuba',
    value: 'cuba',
    code: 'CU',
    countryIso: ISO.CUB,
    phoneCode: '+53',
    flag: '🇨🇺',
  },
  {
    title: 'Cyprus',
    value: 'cyprus',
    code: 'CY',
    countryIso: ISO.CYP,
    phoneCode: '+357',
    flag: '🇨🇾',
  },
  {
    title: 'Czechia',
    value: 'czechia',
    code: 'CZ',
    countryIso: ISO.CZE,
    phoneCode: '+420',
    flag: '🇨🇿',
  },
  {
    title: "Côte d'Ivoire",
    value: 'cote divoire',
    code: 'CI',
    countryIso: ISO.CIV,
    phoneCode: '+225',
    flag: '🇨🇮',
  },
  {
    title: 'Denmark',
    value: 'denmark',
    code: 'DK',
    countryIso: ISO.DNK,
    phoneCode: '+45',
    flag: '🇩🇰',
  },
  {
    title: 'Djibouti',
    value: 'djibouti',
    code: 'DJ',
    countryIso: ISO.DJI,
    phoneCode: '+253',
    flag: '🇩🇯',
  },
  {
    title: 'Dominica',
    value: 'dominica',
    code: 'DM',
    countryIso: ISO.DMA,
    phoneCode: '+1-767',
    flag: '🇩🇲',
  },
  {
    title: 'Dominican Republic',
    value: 'dominican republic',
    code: 'DO',
    countryIso: ISO.DOM,
    phoneCode: '+1',
    flag: '🇩🇴',
  },
  {
    title: 'Ecuador',
    value: 'ecuador',
    code: 'EC',
    countryIso: ISO.ECU,
    phoneCode: '+593',
    flag: '🇪🇨',
  },
  {
    title: 'Egypt',
    value: 'egypt',
    code: 'EG',
    countryIso: ISO.EGY,
    phoneCode: '+20',
    flag: '🇪🇬',
  },
  {
    title: 'El Salvador',
    value: 'el salvador',
    code: 'SV',
    countryIso: ISO.SLV,
    phoneCode: '+503',
    flag: '🇸🇻',
  },
  {
    title: 'Equatorial Guinea',
    value: 'equatorial guinea',
    code: 'GQ',
    countryIso: ISO.GNQ,
    phoneCode: '+240',
    flag: '🇬🇶',
  },
  {
    title: 'Eritrea',
    value: 'eritrea',
    code: 'ER',
    countryIso: ISO.ERI,
    phoneCode: '+291',
    flag: '🇪🇷',
  },
  {
    title: 'Estonia',
    value: 'estonia',
    code: 'EE',
    countryIso: ISO.EST,
    phoneCode: '+372',
    flag: '🇪🇪',
  },
  {
    title: 'Eswatini',
    value: 'eswatini',
    code: 'SZ',
    countryIso: ISO.SWZ,
    phoneCode: '+268',
    flag: '🇸🇿',
  },
  {
    title: 'Ethiopia',
    value: 'ethiopia',
    code: 'ET',
    countryIso: ISO.ETH,
    phoneCode: '+251',
    flag: '🇪🇹',
  },
  {
    title: 'Falkland Islands',
    value: 'falkland islands',
    code: 'FK',
    countryIso: ISO.FLK,
    phoneCode: '+500',
    flag: '🇫🇰',
  },
  {
    title: 'Faroe Islands',
    value: 'faroe islands',
    code: 'FO',
    countryIso: ISO.FRO,
    phoneCode: '+298',
    flag: '🇫🇴',
  },
  {
    title: 'Fiji',
    value: 'fiji',
    code: 'FJ',
    countryIso: ISO.FJI,
    phoneCode: '+679',
    flag: '🇫🇯',
  },
  {
    title: 'Finland',
    value: 'finland',
    code: 'FI',
    countryIso: ISO.FIN,
    phoneCode: '+358',
    flag: '🇫🇮',
  },
  {
    title: 'France',
    value: 'france',
    code: 'FR',
    countryIso: ISO.FRA,
    phoneCode: '+33',
    flag: '🇫🇷',
  },
  {
    title: 'French Guiana',
    value: 'french guiana',
    code: 'GF',
    countryIso: ISO.GUF,
    phoneCode: '+594',
    flag: '🇬🇫',
  },
  {
    title: 'French Polynesia',
    value: 'french polynesia',
    code: 'PF',
    countryIso: ISO.PYF,
    phoneCode: '+689',
    flag: '🇵🇫',
  },
  {
    title: 'Gabon',
    value: 'gabon',
    code: 'GA',
    countryIso: ISO.GAB,
    phoneCode: '+241',
    flag: '🇬🇦',
  },
  {
    title: 'Gambia',
    value: 'gambia',
    code: 'GM',
    countryIso: ISO.GMB,
    phoneCode: '+220',
    flag: '🇬🇲',
  },
  {
    title: 'Georgia',
    value: 'georgia',
    code: 'GE',
    countryIso: ISO.GEO,
    phoneCode: '+995',
    flag: '🇬🇪',
  },
  {
    title: 'Germany',
    value: 'germany',
    code: 'DE',
    countryIso: ISO.DEU,
    phoneCode: '+49',
    flag: '🇩🇪',
  },
  {
    title: 'Ghana',
    value: 'ghana',
    code: 'GH',
    countryIso: ISO.GHA,
    phoneCode: '+233',
    flag: '🇬🇭',
  },
  {
    title: 'Gibraltar',
    value: 'gibraltar',
    code: 'GI',
    countryIso: ISO.GIB,
    phoneCode: '+350',
    flag: '🇬🇮',
  },
  {
    title: 'Greece',
    value: 'greece',
    code: 'GR',
    countryIso: ISO.GRC,
    phoneCode: '+30',
    flag: '🇬🇷',
  },
  {
    title: 'Greenland',
    value: 'greenland',
    code: 'GL',
    countryIso: ISO.GRL,
    phoneCode: '+299',
    flag: '🇬🇱',
  },
  {
    title: 'Grenada',
    value: 'grenada',
    code: 'GD',
    countryIso: ISO.GRD,
    phoneCode: '+1-473',
    flag: '🇬🇩',
  },
  {
    title: 'Guadeloupe',
    value: 'guadeloupe',
    code: 'GP',
    countryIso: ISO.GLP,
    phoneCode: '+590',
    flag: '🇬🇵',
  },
  {
    title: 'Guam',
    value: 'guam',
    code: 'GU',
    countryIso: ISO.GUM,
    phoneCode: '+1-671',
    flag: '🇬🇺',
  },
  {
    title: 'Guatemala',
    value: 'guatemala',
    code: 'GT',
    countryIso: ISO.GTM,
    phoneCode: '+502',
    flag: '🇬🇹',
  },
  {
    title: 'Guinea',
    value: 'guinea',
    code: 'GN',
    countryIso: ISO.GIN,
    phoneCode: '+224',
    flag: '🇬🇳',
  },
  {
    title: 'Guinea-Bissau',
    value: 'guinea-bissau',
    code: 'GW',
    countryIso: ISO.GNB,
    phoneCode: '+245',
    flag: '🇬🇼',
  },
  {
    title: 'Guyana',
    value: 'guyana',
    code: 'GY',
    countryIso: ISO.GUY,
    phoneCode: '+592',
    flag: '🇬🇾',
  },
  {
    title: 'Haiti',
    value: 'haiti',
    code: 'HT',
    countryIso: ISO.HTI,
    phoneCode: '+509',
    flag: '🇭🇹',
  },
  {
    title: 'Holy See',
    value: 'holy see',
    code: 'VA',
    countryIso: ISO.VAT,
    phoneCode: '+379',
    flag: '🇻🇦',
  },
  {
    title: 'Honduras',
    value: 'honduras',
    code: 'HN',
    countryIso: ISO.HND,
    phoneCode: '+504',
    flag: '🇭🇳',
  },
  {
    title: 'Hong Kong',
    value: 'hong kong',
    code: 'HK',
    countryIso: ISO.HKG,
    phoneCode: '+852',
    flag: '🇭🇰',
  },
  {
    title: 'Hungary',
    value: 'hungary',
    code: 'HU',
    countryIso: ISO.HUN,
    phoneCode: '+36',
    flag: '🇭🇺',
  },
  {
    title: 'Iceland',
    value: 'iceland',
    code: 'IS',
    countryIso: ISO.ISL,
    phoneCode: '+354',
    flag: '🇮🇸',
  },
  {
    title: 'India',
    value: 'india',
    code: 'IN',
    countryIso: ISO.IND,
    phoneCode: '+91',
    flag: '🇮🇳',
  },
  {
    title: 'Indonesia',
    value: 'indonesia',
    code: 'ID',
    countryIso: ISO.IDN,
    phoneCode: '+62',
    flag: '🇮🇩',
  },
  {
    title: 'Iran',
    value: 'iran',
    code: 'IR',
    countryIso: ISO.IRN,
    phoneCode: '+98',
    flag: '🇮🇷',
  },
  {
    title: 'Iraq',
    value: 'iraq',
    code: 'IQ',
    countryIso: ISO.IRQ,
    phoneCode: '+964',
    flag: '🇮🇶',
  },
  {
    title: 'Ireland',
    value: 'ireland',
    code: 'IE',
    countryIso: ISO.IRL,
    phoneCode: '+353',
    flag: '🇮🇪',
  },
  {
    title: 'Israel',
    value: 'israel',
    code: 'IL',
    countryIso: ISO.ISR,
    phoneCode: '+972',
    flag: '🇮🇱',
  },
  {
    title: 'Italy',
    value: 'italy',
    code: 'IT',
    countryIso: ISO.ITA,
    phoneCode: '+39',
    flag: '🇮🇹',
  },
  {
    title: 'Jamaica',
    value: 'jamaica',
    code: 'JM',
    countryIso: ISO.JAM,
    phoneCode: '+1-876',
    flag: '🇯🇲',
  },
  {
    title: 'Japan',
    value: 'japan',
    code: 'JP',
    countryIso: ISO.JPN,
    phoneCode: '+81',
    flag: '🇯🇵',
  },
  {
    title: 'Jordan',
    value: 'jordan',
    code: 'JO',
    countryIso: ISO.JOR,
    phoneCode: '+962',
    flag: '🇯🇴',
  },
  {
    title: 'Kazakhstan',
    value: 'kazakhstan',
    code: 'KZ',
    countryIso: ISO.KAZ,
    phoneCode: '+7',
    flag: '🇰🇿',
  },
  {
    title: 'Kenya',
    value: 'kenya',
    code: 'KE',
    countryIso: ISO.KEN,
    phoneCode: '+254',
    flag: '🇰🇪',
  },
  {
    title: 'Kiribati',
    value: 'kiribati',
    code: 'KI',
    countryIso: ISO.KIR,
    phoneCode: '+686',
    flag: '🇰🇮',
  },
  {
    title: "Korea, Democratic People's Republic Of (North Korea)",
    value: 'north korea',
    code: 'KP',
    countryIso: ISO.PRK,
    phoneCode: '+850',
    flag: '🇰🇵',
  },
  {
    title: 'Korea, Republic of (South Korea)',
    value: 'south korea',
    code: 'KR',
    countryIso: ISO.KOR,
    phoneCode: '+82',
    flag: '🇰🇷',
  },
  {
    title: 'Kuwait',
    value: 'kuwait',
    code: 'KW',
    countryIso: ISO.KWT,
    phoneCode: '+965',
    flag: '🇰🇼',
  },
  {
    title: 'Kyrgyzstan',
    value: 'kyrgyzstan',
    code: 'KG',
    countryIso: ISO.KGZ,
    phoneCode: '+996',
    flag: '🇰🇬',
  },
  {
    title: "Lao People's Democratic Republic (Laos)",
    value: 'laos',
    code: 'LA',
    countryIso: ISO.LAO,
    phoneCode: '+856',
    flag: '🇱🇦',
  },
  {
    title: 'Latvia',
    value: 'latvia',
    code: 'LV',
    countryIso: ISO.LVA,
    phoneCode: '+371',
    flag: '🇱🇻',
  },
  {
    title: 'Lebanon',
    value: 'lebanon',
    code: 'LB',
    countryIso: ISO.LBN,
    phoneCode: '+961',
    flag: '🇱🇧',
  },
  {
    title: 'Lesotho',
    value: 'lesotho',
    code: 'LS',
    countryIso: ISO.LSO,
    phoneCode: '+266',
    flag: '🇱🇸',
  },
  {
    title: 'Liberia',
    value: 'liberia',
    code: 'LR',
    countryIso: ISO.LBR,
    phoneCode: '+231',
    flag: '🇱🇷',
  },
  {
    title: 'Libya',
    value: 'libya',
    code: 'LY',
    countryIso: ISO.LBY,
    phoneCode: '+218',
    flag: '🇱🇾',
  },
  {
    title: 'Liechtenstein',
    value: 'liechtenstein',
    code: 'LI',
    countryIso: ISO.LIE,
    phoneCode: '+423',
    flag: '🇱🇮',
  },
  {
    title: 'Lithuania',
    value: 'lithuania',
    code: 'LT',
    countryIso: ISO.LTU,
    phoneCode: '+370',
    flag: '🇱🇹',
  },
  {
    title: 'Luxembourg',
    value: 'luxembourg',
    code: 'LU',
    countryIso: ISO.LUX,
    phoneCode: '+352',
    flag: '🇱🇺',
  },
  {
    title: 'Macao',
    value: 'macao',
    code: 'MO',
    countryIso: ISO.MAC,
    phoneCode: '+853',
    flag: '🇲🇴',
  },
  {
    title: 'Macedonia, North',
    value: 'north macedonia',
    code: 'MK',
    countryIso: ISO.MKD,
    phoneCode: '+389',
    flag: '🇲🇰',
  },
  {
    title: 'Madagascar',
    value: 'madagascar',
    code: 'MG',
    countryIso: ISO.MDG,
    phoneCode: '+261',
    flag: '🇲🇬',
  },
  {
    title: 'Malawi',
    value: 'malawi',
    code: 'MW',
    countryIso: ISO.MWI,
    phoneCode: '+265',
    flag: '🇲🇼',
  },
  {
    title: 'Malaysia',
    value: 'malaysia',
    code: 'MY',
    countryIso: ISO.MYS,
    phoneCode: '+60',
    flag: '🇲🇾',
  },
  {
    title: 'Maldives',
    value: 'maldives',
    code: 'MV',
    countryIso: ISO.MDV,
    phoneCode: '+960',
    flag: '🇲🇻',
  },
  {
    title: 'Mali',
    value: 'mali',
    code: 'ML',
    countryIso: ISO.MLI,
    phoneCode: '+223',
    flag: '🇲🇱',
  },
  {
    title: 'Malta',
    value: 'malta',
    code: 'MT',
    countryIso: ISO.MLT,
    phoneCode: '+356',
    flag: '🇲🇹',
  },
  {
    title: 'Marshall Islands',
    value: 'marshall islands',
    code: 'MH',
    countryIso: ISO.MHL,
    phoneCode: '+692',
    flag: '🇲🇭',
  },
  {
    title: 'Martinique',
    value: 'martinique',
    code: 'MQ',
    countryIso: ISO.MTQ,
    phoneCode: '+596',
    flag: '🇲🇶',
  },
  {
    title: 'Mauritania',
    value: 'mauritania',
    code: 'MR',
    countryIso: ISO.MRT,
    phoneCode: '+222',
    flag: '🇲🇷',
  },
  {
    title: 'Mauritius',
    value: 'mauritius',
    code: 'MU',
    countryIso: ISO.MUS,
    phoneCode: '+230',
    flag: '🇲🇺',
  },
  {
    title: 'Mayotte',
    value: 'mayotte',
    code: 'YT',
    countryIso: ISO.MYT,
    phoneCode: '+262',
    flag: '🇾🇹',
  },
  {
    title: 'Mexico',
    value: 'mexico',
    code: 'MX',
    countryIso: ISO.MEX,
    phoneCode: '+52',
    flag: '🇲🇽',
  },
  {
    title: 'Micronesia, Federated States of',
    value: 'micronesia',
    code: 'FM',
    countryIso: ISO.FSM,
    phoneCode: '+691',
    flag: '🇫🇲',
  },
  {
    title: 'Moldova',
    value: 'moldova',
    code: 'MD',
    countryIso: ISO.MDA,
    phoneCode: '+373',
    flag: '🇲🇩',
  },
  {
    title: 'Monaco',
    value: 'monaco',
    code: 'MC',
    countryIso: ISO.MCO,
    phoneCode: '+377',
    flag: '🇲🇨',
  },
  {
    title: 'Mongolia',
    value: 'mongolia',
    code: 'MN',
    countryIso: ISO.MNG,
    phoneCode: '+976',
    flag: '🇲🇳',
  },
  {
    title: 'Montenegro',
    value: 'montenegro',
    code: 'ME',
    countryIso: ISO.MNE,
    phoneCode: '+382',
    flag: '🇲🇪',
  },
  {
    title: 'Montserrat',
    value: 'montserrat',
    code: 'MS',
    countryIso: ISO.MSR,
    phoneCode: '+1-664',
    flag: '🇲🇸',
  },
  {
    title: 'Morocco',
    value: 'morocco',
    code: 'MA',
    countryIso: ISO.MAR,
    phoneCode: '+212',
    flag: '🇲🇦',
  },
  {
    title: 'Mozambique',
    value: 'mozambique',
    code: 'MZ',
    countryIso: ISO.MOZ,
    phoneCode: '+258',
    flag: '🇲🇿',
  },
  {
    title: 'Myanmar',
    value: 'myanmar',
    code: 'MM',
    countryIso: ISO.MMR,
    phoneCode: '+95',
    flag: '🇲🇲',
  },
  {
    title: 'Namibia',
    value: 'namibia',
    code: 'NA',
    countryIso: ISO.NAM,
    phoneCode: '+264',
    flag: '🇳🇦',
  },
  {
    title: 'Nauru',
    value: 'nauru',
    code: 'NR',
    countryIso: ISO.NRU,
    phoneCode: '+674',
    flag: '🇳🇷',
  },
  {
    title: 'Nepal',
    value: 'nepal',
    code: 'NP',
    countryIso: ISO.NPL,
    phoneCode: '+977',
    flag: '🇳🇵',
  },
  {
    title: 'The Netherlands',
    value: 'the netherlands',
    code: 'NL',
    countryIso: ISO.NLD,
    phoneCode: '+31',
    flag: '🇳🇱',
  },
  {
    title: 'New Caledonia',
    value: 'new caledonia',
    code: 'NC',
    countryIso: ISO.NCL,
    phoneCode: '+687',
    flag: '🇳🇨',
  },
  {
    title: 'New Zealand',
    value: 'new zealand',
    code: 'NZ',
    countryIso: ISO.NZL,
    phoneCode: '+64',
    flag: '🇳🇿',
  },
  {
    title: 'Nicaragua',
    value: 'nicaragua',
    code: 'NI',
    countryIso: ISO.NIC,
    phoneCode: '+505',
    flag: '🇳🇮',
  },
  {
    title: 'Niger',
    value: 'niger',
    code: 'NE',
    countryIso: ISO.NER,
    phoneCode: '+227',
    flag: '🇳🇪',
  },
  {
    title: 'Nigeria',
    value: 'nigeria',
    code: 'NG',
    countryIso: ISO.NGA,
    phoneCode: '+234',
    flag: '🇳🇬',
  },
  {
    title: 'Niue',
    value: 'niue',
    code: 'NU',
    countryIso: ISO.NIU,
    phoneCode: '+683',
    flag: '🇳🇺',
  },
  {
    title: 'Norfolk Island',
    value: 'norfolk island',
    code: 'NF',
    countryIso: ISO.NFK,
    phoneCode: '+672',
    flag: '🇳🇫',
  },
  {
    title: 'Northern Mariana Islands',
    value: 'northern mariana islands',
    code: 'MP',
    countryIso: ISO.MNP,
    phoneCode: '+1-670',
    flag: '🇲🇵',
  },
  {
    title: 'Norway',
    value: 'norway',
    code: 'NO',
    countryIso: ISO.NOR,
    phoneCode: '+47',
    flag: '🇳🇴',
  },
  {
    title: 'Oman',
    value: 'oman',
    code: 'OM',
    countryIso: ISO.OMN,
    phoneCode: '+968',
    flag: '🇴🇲',
  },
  {
    title: 'Pakistan',
    value: 'pakistan',
    code: 'PK',
    countryIso: ISO.PAK,
    phoneCode: '+92',
    flag: '🇵🇰',
  },
  {
    title: 'Palau',
    value: 'palau',
    code: 'PW',
    countryIso: ISO.PLW,
    phoneCode: '+680',
    flag: '🇵🇼',
  },
  {
    title: 'Palestine, State of',
    value: 'palestine, state of',
    code: 'PS',
    countryIso: ISO.PSE,
    phoneCode: '+970',
    flag: '🇵🇸',
  }, // Note: Palestine's status and code might be a sensitive or disputed topic in some contexts
  {
    title: 'Panama',
    value: 'panama',
    code: 'PA',
    countryIso: ISO.PAN,
    phoneCode: '+507',
    flag: '🇵🇦',
  },
  {
    title: 'Papua New Guinea',
    value: 'papua new guinea',
    code: 'PG',
    countryIso: ISO.PNG,
    phoneCode: '+675',
    flag: '🇵🇬',
  },
  {
    title: 'Paraguay',
    value: 'paraguay',
    code: 'PY',
    countryIso: ISO.PRY,
    phoneCode: '+595',
    flag: '🇵🇾',
  },
  {
    title: 'Peru',
    value: 'peru',
    code: 'PE',
    countryIso: ISO.PER,
    phoneCode: '+51',
    flag: '🇵🇪',
  },
  {
    title: 'Philippines',
    value: 'philippines',
    code: 'PH',
    countryIso: ISO.PHL,
    phoneCode: '+63',
    flag: '🇵🇭',
  },
  {
    title: 'Poland',
    value: 'poland',
    code: 'PL',
    countryIso: ISO.POL,
    phoneCode: '+48',
    flag: '🇵🇱',
  },
  {
    title: 'Portugal',
    value: 'portugal',
    code: 'PT',
    countryIso: ISO.PRT,
    phoneCode: '+351',
    flag: '🇵🇹',
  },
  {
    title: 'Puerto Rico',
    value: 'puerto rico',
    code: 'PR',
    countryIso: ISO.PRI,
    phoneCode: '+1',
    flag: '🇵🇷',
  },
  {
    title: 'Qatar',
    value: 'qatar',
    code: 'QA',
    countryIso: ISO.QAT,
    phoneCode: '+974',
    flag: '🇶🇦',
  },
  {
    title: 'Romania',
    value: 'romania',
    code: 'RO',
    countryIso: ISO.ROU,
    phoneCode: '+40',
    flag: '🇷🇴',
  },
  {
    title: 'Russian Federation',
    value: 'russian federation',
    code: 'RU',
    countryIso: ISO.RUS,
    phoneCode: '+7',
    flag: '🇷🇺',
  },
  {
    title: 'Rwanda',
    value: 'rwanda',
    code: 'RW',
    countryIso: ISO.RWA,
    phoneCode: '+250',
    flag: '🇷🇼',
  },
  {
    title: 'Réunion',
    value: 'reunion',
    code: 'RE',
    countryIso: ISO.REU,
    phoneCode: '+262',
    flag: '🇷🇪',
  },
  {
    title: 'Saint Barthelemy',
    value: 'saint barthelemy',
    code: 'BL',
    countryIso: ISO.BLM,
    phoneCode: '+590',
    flag: '🇧🇱',
  },
  {
    title: 'Saint Helena',
    value: 'saint helena',
    code: 'SH',
    countryIso: ISO.SHN,
    phoneCode: '+290',
    flag: '🇸🇭',
  },
  {
    title: 'Saint Kitts and Nevis',
    value: 'saint kitts and nevis',
    code: 'KN',
    countryIso: ISO.KNA,
    phoneCode: '+1-869',
    flag: '🇰🇳',
  },
  {
    title: 'Saint Lucia',
    value: 'saint lucia',
    code: 'LC',
    countryIso: ISO.LCA,
    phoneCode: '+1-758',
    flag: '🇱🇨',
  },
  {
    title: 'Saint Martin (French part)',
    value: 'saint martin',
    code: 'MF',
    countryIso: ISO.MAF,
    phoneCode: '+590',
    flag: '🇲🇫',
  },
  {
    title: 'Saint Pierre and Miquelon',
    value: 'saint pierre and miquelon',
    code: 'PM',
    countryIso: ISO.SPM,
    phoneCode: '+508',
    flag: '🇵🇲',
  },
  {
    title: 'Saint Vincent and the Grenadines',
    value: 'saint vincent and the grenadines',
    code: 'VC',
    countryIso: ISO.VCT,
    phoneCode: '+1-784',
    flag: '🇻🇨',
  },
  {
    title: 'Samoa',
    value: 'samoa',
    code: 'WS',
    countryIso: ISO.WSM,
    phoneCode: '+685',
    flag: '🇼🇸',
  },
  {
    title: 'San Marino',
    value: 'san marino',
    code: 'SM',
    countryIso: ISO.SMR,
    phoneCode: '+378',
    flag: '🇸🇲',
  },
  {
    title: 'Sao Tome and Principe',
    value: 'sao tome and principe',
    code: 'ST',
    countryIso: ISO.STP,
    phoneCode: '+239',
    flag: '🇸🇹',
  },
  {
    title: 'Saudi Arabia',
    value: 'saudi arabia',
    code: 'SA',
    countryIso: ISO.SAU,
    phoneCode: '+966',
    flag: '🇸🇦',
  },
  {
    title: 'Senegal',
    value: 'senegal',
    code: 'SN',
    countryIso: ISO.SEN,
    phoneCode: '+221',
    flag: '🇸🇳',
  },
  {
    title: 'Serbia',
    value: 'serbia',
    code: 'RS',
    countryIso: ISO.SRB,
    phoneCode: '+381',
    flag: '🇷🇸',
  },
  {
    title: 'Seychelles',
    value: 'seychelles',
    code: 'SC',
    countryIso: ISO.SYC,
    phoneCode: '+248',
    flag: '🇸🇨',
  },
  {
    title: 'Sierra Leone',
    value: 'sierra leone',
    code: 'SL',
    countryIso: ISO.SLE,
    phoneCode: '+232',
    flag: '🇸🇱',
  },
  {
    title: 'Singapore',
    value: 'singapore',
    code: 'SG',
    countryIso: ISO.SGP,
    phoneCode: '+65',
    flag: '🇸🇬',
  },
  {
    title: 'Slovakia',
    value: 'slovakia',
    code: 'SK',
    countryIso: ISO.SVK,
    phoneCode: '+421',
    flag: '🇸🇰',
  },
  {
    title: 'Slovenia',
    value: 'slovenia',
    code: 'SI',
    countryIso: ISO.SVN,
    phoneCode: '+386',
    flag: '🇸🇮',
  },
  {
    title: 'Solomon Islands',
    value: 'solomon islands',
    code: 'SB',
    countryIso: ISO.SLB,
    phoneCode: '+677',
    flag: '🇸🇧',
  },
  {
    title: 'Somalia',
    value: 'somalia',
    code: 'SO',
    countryIso: ISO.SOM,
    phoneCode: '+252',
    flag: '🇸🇴',
  },
  {
    title: 'South Africa',
    value: 'south africa',
    code: 'ZA',
    countryIso: ISO.ZAF,
    phoneCode: '+27',
    flag: '🇿🇦',
  },
  {
    title: 'South Sudan',
    value: 'south sudan',
    code: 'SS',
    countryIso: ISO.SSD,
    phoneCode: '+211',
    flag: '🇸🇸',
  },
  {
    title: 'Spain',
    value: 'spain',
    code: 'ES',
    countryIso: ISO.ESP,
    phoneCode: '+34',
    flag: '🇪🇸',
  },
  {
    title: 'Sri Lanka',
    value: 'sri lanka',
    code: 'LK',
    countryIso: ISO.LKA,
    phoneCode: '+94',
    flag: '🇱🇰',
  },
  {
    title: 'Sudan',
    value: 'sudan',
    code: 'SD',
    countryIso: ISO.SDN,
    phoneCode: '+249',
    flag: '🇸🇩',
  },
  {
    title: 'Suriname',
    value: 'suriname',
    code: 'SR',
    countryIso: ISO.SUR,
    phoneCode: '+597',
    flag: '🇸🇷',
  },
  {
    title: 'Sweden',
    value: 'sweden',
    code: 'SE',
    countryIso: ISO.SWE,
    phoneCode: '+46',
    flag: '🇸🇪',
  },
  {
    title: 'Switzerland',
    value: 'switzerland',
    code: 'CH',
    countryIso: ISO.CHE,
    phoneCode: '+41',
    flag: '🇨🇭',
  },
  {
    title: 'Syria',
    value: 'syria',
    code: 'SY',
    countryIso: ISO.SYR,
    phoneCode: '+963',
    flag: '🇸🇾',
  },
  {
    title: 'Taiwan',
    value: 'taiwan',
    code: 'TW',
    countryIso: ISO.TWN,
    phoneCode: '+886',
    flag: '🇹🇼',
  }, // Note: Taiwan's status and code might be a sensitive or disputed topic in some contexts
  {
    title: 'Tajikistan',
    value: 'tajikistan',
    code: 'TJ',
    countryIso: ISO.TJK,
    phoneCode: '+992',
    flag: '🇹🇯',
  },
  {
    title: 'Tanzania',
    value: 'tanzania',
    code: 'TZ',
    countryIso: ISO.TZA,
    phoneCode: '+255',
    flag: '🇹🇿',
  },
  {
    title: 'Thailand',
    value: 'thailand',
    code: 'TH',
    countryIso: ISO.THA,
    phoneCode: '+66',
    flag: '🇹🇭',
  },
  {
    title: 'Timor-Leste',
    value: 'timor-leste',
    code: 'TL',
    countryIso: ISO.TLS,
    phoneCode: '+670',
    flag: '🇹🇱',
  },
  {
    title: 'Togo',
    value: 'togo',
    code: 'TG',
    countryIso: ISO.TGO,
    phoneCode: '+228',
    flag: '🇹🇬',
  },
  {
    title: 'Tokelau',
    value: 'tokelau',
    code: 'TK',
    countryIso: ISO.TKL,
    phoneCode: '+690',
    flag: '🇹🇰',
  },
  {
    title: 'Tonga',
    value: 'tonga',
    code: 'TO',
    countryIso: ISO.TON,
    phoneCode: '+676',
    flag: '🇹🇴',
  },
  {
    title: 'Trinidad and Tobago',
    value: 'trinidad and tobago',
    code: 'TT',
    countryIso: ISO.TTO,
    phoneCode: '+1-868',
    flag: '🇹🇹',
  },
  {
    title: 'Tunisia',
    value: 'tunisia',
    code: 'TN',
    countryIso: ISO.TUN,
    phoneCode: '+216',
    flag: '🇹🇳',
  },
  {
    title: 'Turkey',
    value: 'turkey',
    code: 'TR',
    countryIso: ISO.TUR,
    phoneCode: '+90',
    flag: '🇹🇷',
  },
  {
    title: 'Turkmenistan',
    value: 'turkmenistan',
    code: 'TM',
    countryIso: ISO.TKM,
    phoneCode: '+993',
    flag: '🇹🇲',
  },
  {
    title: 'Turks and Caicos Islands',
    value: 'turks and caicos islands',
    code: 'TC',
    countryIso: ISO.TCA,
    phoneCode: '+1-649',
    flag: '🇹🇨',
  },
  {
    title: 'Tuvalu',
    value: 'tuvalu',
    code: 'TV',
    countryIso: ISO.TUV,
    phoneCode: '+688',
    flag: '🇹🇻',
  },
  {
    title: 'Uganda',
    value: 'uganda',
    code: 'UG',
    countryIso: ISO.UGA,
    phoneCode: '+256',
    flag: '🇺🇬',
  },
  {
    title: 'Ukraine',
    value: 'ukraine',
    code: 'UA',
    countryIso: ISO.UKR,
    phoneCode: '+380',
    flag: '🇺🇦',
  },
  {
    title: 'United Arab Emirates',
    value: 'united arab emirates',
    code: 'AE',
    countryIso: ISO.ARE,
    phoneCode: '+971',
    flag: '🇦🇪',
  },
  {
    title: 'United Kingdom',
    value: 'united kingdom',
    code: 'GB',
    countryIso: ISO.GBR,
    phoneCode: '+44',
    flag: '🇬🇧',
  },
  {
    title: 'United States',
    value: 'united states',
    code: 'US',
    countryIso: ISO.USA,
    phoneCode: '+1',
    flag: '🇺🇸',
  },
  {
    title: 'Uruguay',
    value: 'uruguay',
    code: 'UY',
    countryIso: ISO.URY,
    phoneCode: '+598',
    flag: '🇺🇾',
  },
  {
    title: 'Uzbekistan',
    value: 'uzbekistan',
    code: 'UZ',
    countryIso: ISO.UZB,
    phoneCode: '+998',
    flag: '🇺🇿',
  },
  {
    title: 'Vanuatu',
    value: 'vanuatu',
    code: 'VU',
    countryIso: ISO.VUT,
    phoneCode: '+678',
    flag: '🇻🇺',
  },
  {
    title: 'Venezuela',
    value: 'venezuela',
    code: 'VE',
    countryIso: ISO.VEN,
    phoneCode: '+58',
    flag: '🇻🇪',
  },
  {
    title: 'Vietnam',
    value: 'vietnam',
    code: 'VN',
    countryIso: ISO.VNM,
    phoneCode: '+84',
    flag: '🇻🇳',
  },
  {
    title: 'Virgin Islands, British',
    value: 'british virgin islands',
    code: 'VG',
    countryIso: ISO.VGB,
    phoneCode: '+1-284',
    flag: '🇻🇬',
  },
  {
    title: 'Virgin Islands, U.S.',
    value: 'u.s. virgin islands',
    code: 'VI',
    countryIso: ISO.VIR,
    phoneCode: '+1-340',
    flag: '🇻🇮',
  },
  {
    title: 'Wallis and Futuna',
    value: 'wallis and futuna',
    code: 'WF',
    countryIso: ISO.WLF,
    phoneCode: '+681',
    flag: '🇼🇫',
  },
  {
    title: 'Yemen',
    value: 'yemen',
    code: 'YE',
    countryIso: ISO.YEM,
    phoneCode: '+967',
    flag: '🇾🇪',
  },
  {
    title: 'Zambia',
    value: 'zambia',
    code: 'ZM',
    countryIso: ISO.ZMB,
    phoneCode: '+260',
    flag: '🇿🇲',
  },
  {
    title: 'Zimbabwe',
    value: 'zimbabwe',
    code: 'ZW',
    countryIso: ISO.ZWE,
    phoneCode: '+263',
    flag: '🇿🇼',
  },
];
